import React from 'react';

import Typography from 'components/Typography';
import { NumberValueFormatter } from 'intl';

import { IDescriptionDecimal } from './interfaces';

export const DescriptionDecimal: React.FC<IDescriptionDecimal> = ({
  value,
  maximumFractionDigits = 2,
  ...other
}) => {
  return (
    <Typography {...other}>
      <NumberValueFormatter.Decimal
        value={value}
        maximumFractionDigits={maximumFractionDigits}
      />
    </Typography>
  );
};
